const categoriesSlider = document.querySelectorAll('[data-slider="categories-slider"]');

const categoriesSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  freeMode: true,
  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
      freeMode: false,
    },
  },
};

const initCategoriesSlider = () => {
  categoriesSlider.forEach((el) => windowWidth() > 767 && new Swiper(el, categoriesSliderOptions));
};

initCategoriesSlider();

setupResponsiveSliders({
  sliderElements: categoriesSlider,
  breakpoint: 767,
  initSlider: initCategoriesSlider,
  mobileFallback: enableScrollbarSync,
  parentSelector: '[data-slider-parent]',
});
